import { useNavigate } from 'react-router-dom';
import '../../css/home/CategoryNav.css';
import { useLang } from '../../i18n';

const CAT_ICONS = {
  sports: (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
      <circle cx="8.5" cy="8.5" r="7.5" stroke="#fff" strokeWidth="1.2" />
      <path d="M8.5 3.5l2.4 1.7-.9 2.8H7l-.9-2.8zM3 8.2l2.6.4M14 8.2l-2.6.4M5.7 13l1.3-2.3M11.3 13L10 10.7" stroke="#fff" strokeWidth="1" strokeLinejoin="round" />
    </svg>
  ),
  livebetting: (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
      <circle cx="8.5" cy="9.5" r="6" stroke="#fff" strokeWidth="1.2" />
      <path d="M8.5 6.5V9.5l2 1.3M6.5 2h4M8.5 2v1.5" stroke="#fff" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  ),
};

const CATEGORIES = [
  { id: 'sports',      labelKey: 'home.catSports',      path: '/sports' },
  { id: 'livebetting', labelKey: 'home.catLiveBetting',  path: '/live-betting' },
];

export default function CategoryNav() {
  const navigate = useNavigate();
  const { t } = useLang();

  return (
    <nav className="catnav">
      {CATEGORIES.map((c) => (
        <button
          key={c.id}
          className="catnav-item"
          onClick={() => navigate(c.path)}
        >
          {CAT_ICONS[c.id]}
          <span className="catnav-label">{t(c.labelKey)}</span>
        </button>
      ))}
    </nav>
  );
}
